// client/src/pages/LoadCalculator.js
import React, { useContext, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import useTrial from '../hooks/useTrial';

const LoadCalculator = () => {
  const { user } = useContext(AuthContext);
  const { trialCount, decrementTrial } = useTrial();

  useEffect(() => {
    // Example of decrement logic
    if (trialCount > 0) {
      decrementTrial();
    }
  }, []);

  return (
    <div>
      <h2>Solar Load Calculator</h2>
      {trialCount > 0 ? (
        <p>You have {trialCount} trial uses left.</p>
      ) : (
        <p>Your trial has expired. Upgrade to a paid plan to continue.</p>
      )}
    </div>
  );
};

export default LoadCalculator;
